import { FC } from 'react'
import PerText from '../../Text'
import { Colors } from '../../../util/types'

interface Props {
  number: number | string
  color?: Colors
  outOf?: string
  numberFontSize?: 's' | 'xxxl' | 'xs' | 'm' | 'l' | 'xl' | 'xl2' | 'xxl'
  outOfFontSize?: 's' | 'xxxl' | 'xs' | 'm' | 'l' | 'xl' | 'xl2' | 'xxl'
}

export const PerInfoBoxNumberElement: FC<Props> = ({ number, color, outOf, numberFontSize = 'xxxl', outOfFontSize = 'l' }) => {
  return (
    <PerText color={color ? color : 'primary'} fontSize={numberFontSize}>
      {number}
      {outOf && (
        <PerText color="secondary" fontSize={outOfFontSize} display="inline">
          / {outOf}
        </PerText>
      )}
    </PerText>
  )
}
